import { render, staticRenderFns } from "./ActualizarExpiracionPago.vue?vue&type=template&id=22198df4&scoped=true"
import script from "./ActualizarExpiracionPago.vue?vue&type=script&lang=js"
export * from "./ActualizarExpiracionPago.vue?vue&type=script&lang=js"
import style0 from "./ActualizarExpiracionPago.vue?vue&type=style&index=0&id=22198df4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22198df4",
  null
  
)

export default component.exports